import { Icon, Typography } from '@globalmed/atlas-ui';
import { useTranslation } from 'react-i18next';
import styles from './ModalTitle.module.css';

type TProps = {
  isEditMode?: boolean;
};

/**
 * Title of the create organization modal, showing a hospital icon
 * alongside the translated "Create Organization" label, or "Organization
 * Settings" when editing an existing organization.
 * @param props - Component props.
 * @param props.isEditMode - If `true`, shows the edit-mode title.
 * @returns The modal title
 */
export const ModalTitle = ({ isEditMode }: TProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.title}>
      <Icon
        name="Hospital"
        size="24px"
        color="var(--colors-primary600)"
        decorative
      />
      <Typography as="span" fontWeight={700} fontSize="18px">
        {t(
          isEditMode
            ? 'create-organization-modal.organization-settings'
            : 'nav-panel.create-organization',
        )}
      </Typography>
    </div>
  );
};
